import { State, createTokenClass, Plugin, registerPlugin, stringToArray, registerTokenPlugin } from 'linkifyjs'

import { useStoreEnvSettings } from '@/shared/store/environment'

/**
 * @param baseUrl
 * @param projectCodes
 * @returns
 */
export const registerJiraPlugin = (baseUrl: string, projectCodes: string[] = []): Plugin => {

  const TicketToken = createTokenClass('jira', {
    isLink: true,
    toHref () {
      return `${baseUrl}${this.toString()}`
    },
  })

  projectCodes.forEach((project) => {
    registerTokenPlugin(`jira${project}`, ({ scanner }) => {
      scanner.start.ts(stringToArray(project.toLocaleLowerCase()), project)
    })
  })

  /**
  * @type {import('linkifyjs').Plugin}
  */
  return ({ scanner, parser }) => {

    const { HYPHEN, NUM } = scanner.tokens
    const Ticket = new State(TicketToken)
    projectCodes.forEach((project) => {
      // @ts-expect-error: error with types at linkifyjs package
      parser.start.tt(project).tt(HYPHEN).tt(NUM, Ticket)
    })
  }
}

export const LinkifyPlugin = {
  install: () => {
    const { getSettingByKey, onInitialized } = useStoreEnvSettings()
    onInitialized().then(() => {
      const url = getSettingByKey('jiraUrlPrefix')
      const projects = getSettingByKey<Array<string>>('jiraProjects')
      if (url && projects.value.length) {
        if (!url.value.endsWith('/')) {
          url.value += '/'
        }
        registerPlugin('jira', registerJiraPlugin(url.value, projects.value))
      }
    })
  },
}
